import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-two-sided',
  templateUrl: './tooltip-info-two-sided.component.html',
  standalone: false
})
export class TooltipInfoTwoSidedComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
